import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 30px;
  width: 100%;
  
  @media(max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;

const Section = styled.div`
  background: var(--glass-1);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius, 16px);
  padding: 30px;
  backdrop-filter: blur(var(--glass-blur, 10px));
`;

const Title = styled.h3`
  margin: 0 0 20px 0;
  color: var(--text-primary);
  font-size: 18px;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 15px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 14px;
  background: rgba(0,0,0,0.2);
  border: 1px solid var(--glass-border);
  border-radius: 8px;
  color: var(--text-primary);
`;

const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  font-size: 14px;
  color: var(--text-secondary);
  
  &.total {
    font-size: 18px;
    font-weight: bold;
    color: var(--text-primary);
    border-top: 1px solid var(--glass-border);
    padding-top: 15px;
    margin-top: 5px;
  }
`;

const PayBtn = styled.button`
  width: 100%;
  padding: 15px;
  background: linear-gradient(135deg, var(--success, #10b981), #059669);
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 20px;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3);
`;

const CheckoutWidget = ({ node }) => {
  return (
    <Wrapper>
      <Section>
        <Title>Lieferadresse</Title>
        <Row>
          <Input placeholder="Vorname" />
          <Input placeholder="Nachname" />
        </Row>
        <Input placeholder="Straße und Hausnummer" style={{marginBottom: 15}} />
        <Row>
          <Input placeholder="PLZ" />
          <Input placeholder="Ort" />
        </Row>
        <Title style={{marginTop: 30}}>Zahlungsart</Title>
        <select style={{width:'100%', padding:'12px', borderRadius:'8px', background:'rgba(0,0,0,0.2)', color:'#fff', border:'1px solid var(--glass-border)'}}>
          <option>Kreditkarte</option>
          <option>PayPal</option>
          <option>SEPA Lastschrift</option>
        </select>
      </Section>
      <Section>
        <Title>Bestellübersicht</Title>
        <SummaryRow><span>iPhone 15 Pro</span> <span>€1,199.00</span></SummaryRow>
        <SummaryRow><span>o2 Mobile M</span> <span>€29.99 mtl.</span></SummaryRow>
        <SummaryRow><span>Versand</span> <span>€4.99</span></SummaryRow>
        <SummaryRow className="total"><span>Gesamtsumme</span> <span>€1,233.98</span></SummaryRow>
        <PayBtn className="tef-bubbles">Jetzt Zahlungpflichtig bestellen</PayBtn>
      </Section>
    </Wrapper>
  );
};

registry.register('checkout_form', {
  label: 'Checkout Page',
  icon: '💳',
  category: 'ecommerce',
  defaultContent: {},
  defaultStyle: {},
  render: CheckoutWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Hinweis', fields: [{name:'info', label:'Checkout', type:'text', readOnly:true }] }] }
  ]
});
